/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraphTagList } from '../../models/graph-tag-list';
import { GraphTagSearch } from '../../models/graph-tag-search';
import { SortDirection } from '../../models/sort-direction';
import { TagSortFieldName } from '../../models/tag-sort-field-name';

export interface GetTags$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the tag name
 *   * ALIAS : the tag alias
 *   * UNIT : the tag unit
 *   * LAST_VALUES_LAST_VALUE_DATETIME : the tag last value datetime
 *   * LAST_VALUES_LAST_VALUE : the tag last value
 *   * VALUE_TYPE : the tag value type
 */
  sortFieldName?: TagSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search graph tags
     */
    body?: GraphTagSearch
}

export function getTags(http: HttpClient, rootUrl: string, params: GetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphTagList>> {
  const rb = new RequestBuilder(rootUrl, getTags.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GraphTagList>;
    })
  );
}

getTags.PATH = '/stations/{uid}/graph/tags/search';
